import React, { useCallback, useState, useEffect } from "react";
import { store } from "@root/store/index";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import {
  Select,
  Form,
  Button,
  Table,
  Input,
  message,
  Space,
  Upload,
  Modal,
  Checkbox,
} from "antd";
import {
  SearchOutlined,
  RedoOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  getTrain,
  setStatus,
  resetPassword,
  getTemplate,
} from "@root/common/service";
import axios from "axios";

import type { ColumnsType } from "antd/es/table";
const { NODE_ENV } = process.env;
const prefixpath = NODE_ENV === "development" ? "" : "/county-manager";
const { Option } = Select;
interface DataType {
  key: number | string;
  nickName: string;
  sex: number | string;
  identityNumber: number | string;
  phonenumber: number | string;
  subjectId: number | string;
  baseHealthTitle: number | string;
  createTime: number | string;
  baseRegistrationStatus: number | string;
  status: number | string;
  userId: number | string;
}

function Index() {
  const { centerClassification = [] } = useSelector(
    (state: RootState) => state.directionaries
  );
  // 所在中心数据反显
  function GetbaseCenterCategoryList(
    centerClassification: any[],
    centerList: any[]
  ) {
    return centerList
      .map((item) => {
        return centerClassification.find((it) => it.id === Number(item)).name;
      })
      .join(",");
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "序号",
      render: (text, record, index) => `${index + 1}`,
      width: 30,
    },
    {
      title: "学员来源",
      dataIndex: "baseRegistrationStatus",
      key: "baseRegistrationStatus",
      width: 72,
      render: (_, item) => {
        const { baseRegistrationStatus } = item;
        return (
          <p>
            {baseRegistrationStatus === "0" && <span>个人注册</span>}
            {baseRegistrationStatus === "1" && <span>机构导入</span>}
            {baseRegistrationStatus === "2" && <span>初始化</span>}
          </p>
        );
      },
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "性别",
      dataIndex: "sex",
      key: "sex",
      width: 30,
      render: (_: any, record: any) => {
        return <span>{_ === "0" ? "男" : "女"}</span>;
      },
    },
    {
      title: "身份证号码",
      dataIndex: "identityNumber",
      key: "identityNumber",
    },
    {
      title: "手机号",
      dataIndex: "phonenumber",
      key: "phonenumber",
    },
    {
      title: "学科",
      dataIndex: "subjectId",
      key: "subjectId",
      render: (_: any, record: any) => {
        const item = subjectIdArr.find((item: any) => item.id === _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "职称",
      dataIndex: "baseHealthTitle",
      key: "baseHealthTitle",
      render: (_: any, record: any) => {
        // eslint-disable-next-line eqeqeq
        const item = titleData.find((item: any) => item.id == _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "乡镇医疗机构名称",
      dataIndex: "townshipOrgName",
      key: "townshipOrgName",
    },
    {
      title: "所在中心",
      dataIndex: "baseCenterCategoryList",
      key: "baseCenterCategoryList",
      render: (_: string[], record: any) => {
        return (
          <span>
            {Array.isArray(_)
              ? GetbaseCenterCategoryList(centerClassification, _)
              : ""}
          </span>
        );
      },
    },
    {
      title: "学员状态",
      dataIndex: "status",
      key: "status",
      render: (_, a) =>
        (() => {
          if (a.status === "0") {
            return <span style={{ color: "#2a82e4" }}>启用(正常)</span>;
          } else if (a.status === "1") {
            return <span style={{ color: "#d43030" }}>停用</span>;
          } else if (a.status === "2") {
            return <span>未启用</span>;
          } else if (a.status === "3") {
            return <span>启用修改</span>;
          } else if (a.status === "4") {
            return <span>调出</span>;
          }
        })(),
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="small">
          {e.status === "0" ? (
            <Button
              style={{
                padding: "0 3px",
                backgroundColor: "#d43030",
                color: "#fff",
                borderRadius: "8px",
              }}
              onClick={() => set(e, "1")}
              type="text"
              disabled={store.getState().userInfo.userId === e.userId}
            >
              停用
            </Button>
          ) : (
            ""
          )}
          {e.status === "1" ? (
            <Button
              style={{
                padding: "0 3px",
                backgroundColor: "#2a82e4",
                color: "#fff",
                borderRadius: "8px",
              }}
              onClick={() => set(e, "0")}
              type="text"
              disabled={store.getState().userInfo.userId === e.userId}
            >
              启用
            </Button>
          ) : (
            ""
          )}
          <Button
            style={{
              padding: "0 3px",
              backgroundColor: "#00baad",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => set(e, "4")}
            disabled={
              e.status === "4" || store.getState().userInfo.userId === e.userId
            }
            type="text"
          >
            调出
          </Button>
          <Button
            style={{
              padding: "0 3px",
              backgroundColor: "#ff8d1a",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => resetPwd(e)}
            disabled={e.status === "4"}
            type="text"
          >
            重置密码
          </Button>
        </Space>
      ),
    },
  ];

  // const data: DataType[]

  const [form1] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [titleData, setTtitleData] = useState<any>([]);
  const [subjectIdArr, setSubjectIdArr] = useState<any>([]);
  const [fileList, setFileList] = useState<any>([]);
  const [isImport, setImport] = useState<any>(false);
  const [isCheck, setIsCheck] = useState<any>(false);

  // const [userInfo, setUserInfo] = useState<any>()

  const getAll = async () => {
    const { rows } = await getTrain(``);
    rows.forEach((el: any) => {
      el.key = el.id;
    });
    setData(rows);
  };

  useEffect(() => {
    console.log(store.getState());
    setTtitleData(store.getState().directionaries.titleData);
    setSubjectIdArr(store.getState().directionaries.subjectData);
    // setUserInfo(store.getState().userInfo.instituteId)
    getAll();
  }, []);

  const handleChange = useCallback((e: any) => {
    console.log(e);
  }, []);
  const onFinish = useCallback((e: any) => {
    console.log(e);
    const keys: Array<string> = Object.keys(e);
    const values = Object.values(e);
    const arr: any = values.reduce(function (r, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`;
      }
      return r;
    }, ``);
    console.log(arr);
    const getOne = async () => {
      const { rows } = await getTrain(arr.slice(0, -1));
      setData(rows);
    };
    getOne();
  }, []);
  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, []);
  const onReset = useCallback(() => {
    form1.resetFields();
    getAll();
  }, [form1]);

  const exportLog = useCallback(() => {
    console.log(form1.getFieldsValue());
    const formData: any = form1.getFieldsValue();
    const keys = Object.keys(formData);
    const values = Object.values(formData);
    const obj: any = values.reduce(function (r: any, el, i) {
      if (!!el) {
        r[keys[i]] = el;
      }
      return r;
    }, {});

    const {
      userInfo: { access_token, instituteId },
    } = store.getState();
    axios({
      method: "post",
      url: `/dev-api/system/user/export?instituteId=${instituteId}`,
      data: obj,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${access_token}`,
      },
    }).then((res) => {
      console.log(res);
      const b = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      console.log(b);
      let a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.setAttribute("download", "excel.xlsx");
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    });
  }, [form1]);

  const importUser = useCallback(() => {
    setImport(true);
  }, []);
  const set = useCallback((e: any, status: string) => {
    console.log(e);
    const setOne = async () => {
      const { code } = await setStatus({
        userId: e.userId,
        status,
      });
      if (code === 200) {
        message.success("修改成功");
        getAll();
      }
    };
    setOne();
  }, []);
  const resetPwd = useCallback((e: any) => {
    console.log(e);
    const resetOne = async () => {
      const { code } = await resetPassword({
        userId: e.userId,
        password: "000000",
      });
      if (code === 200) {
        message.success("重置密码成功");
      }
    };
    resetOne();
  }, []);

  const getTemplateD = useCallback(() => {
    const downloadOne = async () => {
      const { rows, code } = await getTemplate();
      if (code === 200) {
        window.location.href = rows[0].exceltemplateaddress;
      }
    };
    downloadOne();
  }, []);

  return (
    <div style={{ padding: "15px", background: "#fff" }}>
      <div className="top">
        <Form
          name="trainSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="学员来源" name="baseRegistrationStatus">
            <Select
              placeholder="请选择来源"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              <Option value="0">自行注册</Option>
              <Option value="1">统一导入</Option>
            </Select>
          </Form.Item>

          <Form.Item label="姓名" name="nickName">
            <Input style={{ width: 120 }} allowClear key={"nickName"} />
          </Form.Item>

          <Form.Item label="证件号" name="identityNumber">
            <Input style={{ width: 200 }} allowClear key={"identityNumber"} />
          </Form.Item>

          <Form.Item label="手机号" name="phonenumber">
            <Input style={{ width: 140 }} allowClear key={"phonenumber"} />
          </Form.Item>

          <Form.Item label="学科" name="subjectId">
            <Select
              placeholder="请选择学科"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {subjectIdArr.map((e: any, i: number) => {
                return (
                  <Option value={e.id} key={i}>
                    {e.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item label="职称" name="baseHealthTitle">
            <Select
              placeholder="请选择职称"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {titleData.map((e: any, i: number) => {
                return (
                  <Option value={e.id} key={i}>
                    {e.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item label="学员状态" name="status">
            <Select
              placeholder="请选择状态"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              <Option value="0">启用</Option>
              <Option value="1">停用</Option>
              <Option value="2">未启用</Option>
              <Option value="3">启用修改</Option>
              <Option value="4">调出</Option>
            </Select>
          </Form.Item>

          <Form.Item style={{ marginLeft: "30px" }}>
            <Button type="primary" htmlType="submit">
              <SearchOutlined />
              查询
            </Button>
            <Button
              type="primary"
              onClick={onReset}
              style={{ marginLeft: "15px" }}
            >
              <RedoOutlined />
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className="midBtn" style={{ display: "flex" }}>
        <Button type="primary" onClick={importUser}>
          导入
        </Button>
        <Button type="primary" onClick={exportLog}>
          导出
        </Button>
        <Button type="primary" onClick={getTemplateD}>
          模板下载
        </Button>
      </div>

      <div>
        <Table size="middle" columns={columns} dataSource={data} />
      </div>

      <Modal
        title="导入文件"
        visible={isImport}
        onCancel={() => {
          setImport(false);
        }}
        footer={[]}
      >
        <Upload
          maxCount={1}
          accept=".xlsx"
          showUploadList={false}
          onRemove={(file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
          }}
          beforeUpload={(file) => {
            console.log(file);
            if (file.size > 307200) {
              message.error("文件不可大于300K");
              return;
            }
            const formData = new FormData();
            formData.append("file", file);
            setFileList([...fileList, file]);
            const {
              userInfo: { access_token },
            } = store.getState();
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${access_token}`,
              },
            };
            axios
              .post(
                `${prefixpath}/dev-api/system/user/importData?updateSupport=${isCheck}`,
                formData,
                config
              )
              .then(
                (res: any) => {
                  console.log(res);
                  if (res.data.code === 200) {
                    message.success({
                      content: `${res.data.msg}`.split("<br/>").join("\n"),
                      style: { whiteSpace: "pre-wrap" },
                    });
                    setImport(false);
                    getAll();
                  } else {
                    message.error({
                      content: `${res.data.msg}`.split("<br/>").join("\n"),
                      style: { whiteSpace: "pre-wrap" },
                    });
                  }
                },
                (err) => {
                  message.error(`${err}`);
                }
              );
            return false;
          }}
        >
          <Button type="primary" icon={<UploadOutlined />}>
            导入
          </Button>
        </Upload>
        <Checkbox
          style={{ marginLeft: "20px" }}
          onChange={() => {
            setIsCheck(!isCheck);
          }}
        >
          是否更新已经存在的用户数据
        </Checkbox>
      </Modal>
    </div>
  );
}

export default Index;
